import { isNull, isNumber, isUndefined } from 'lodash';

export function isNumberFinite(value: unknown): boolean {
  return isNumber(value) && isFinite(value);
}

export function extractDeepPropertyByMapKey(obj: unknown, map: string): unknown {
  const keys = map.split('.');
  const head = keys.shift();

  return keys.reduce((prop: unknown, key: string) => {
    return !isUndefined(prop) && !isNull(prop) && !isUndefined(prop[key]) ? prop[key] : undefined;
  }, obj[head || '']);
}

export function extractDeepPropertyByParentMapKey(obj: unknown, map: string): { props: unknown; tail: unknown } {
  const keys = map.split('.');
  const tail = keys.pop();
  const props = extractDeepPropertyByMapKey(obj, keys.join('.'));

  return { props, tail };
}
